import React from 'react';
import PropTypes from 'prop-types';

export class BasicForm extends React.Component {

  getLabelUtilText (object, input) {
    console.warn('Form Field components need to implement its own function of [getLabelUtilText]');
  }

  handleFocusInput = (cb) => (e) => {
    cb(e);
    this.props.inputCallbacks.onFocus(e);
  }

  handleBlurInput = (cb) => (e) => {
    cb(e);
    this.props.inputCallbacks.onBlur(e);
  }
}
